export const APP_INFO: string[] = [
  " Miindset has been designed by psychologists to help improve your mind, your mental health and well being.",
  "Using A.I. Miindset curates helpful information IMMEDIATELY such as articles, videos and podcasts based on how you feel. The more media you consume and times you complete the wellness checker the more the A.I. will learn.",
  "We are not a replacement for diagnosis or psychotherapy.",
];
